var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "LanguageSet" },
    [
      _c(
        "div",
        { staticClass: "buttonBox" },
        [
          _c(
            "el-button",
            {
              style: { fontSize: _vm.fonts },
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.addClick }
            },
            [_vm._v(_vm._s(_vm.$t("LanguageSet.add")))]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tableBox" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "ks", label: _vm.language, align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "v1", label: _vm.content, align: "center" }
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: _vm.operation,
                  width: "100",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-button", {
                          attrs: {
                            type: "text",
                            icon: "el-icon-edit",
                            circle: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.setData(scope)
                            }
                          }
                        }),
                        _c("el-button", {
                          attrs: {
                            type: "text",
                            icon: "el-icon-delete",
                            circle: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.deleteData(scope)
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.titles,
            visible: _vm.dialogFormVisible,
            width: "30%",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.language } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("placeHolder.pleaseSelect")
                      },
                      on: {
                        change: _vm.LanguageChange,
                        "visible-change": _vm.visibleChange
                      },
                      model: {
                        value: _vm.form.k,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "k", $$v)
                        },
                        expression: "form.k"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { attrs: { label: "中文(简体)", value: "zh-cn" } },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v("中文(简体)")
                          ]),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                color: "#8492a6",
                                "font-size": "13px"
                              }
                            },
                            [_vm._v("zh-cn")]
                          )
                        ]
                      ),
                      _vm._l(_vm.Languageoptions, function(item, index) {
                        return _c(
                          "el-option",
                          {
                            key: index,
                            attrs: {
                              label: item.langName,
                              value: item.langCode
                            }
                          },
                          [
                            _c("span", { staticStyle: { float: "left" } }, [
                              _vm._v(_vm._s(item.langName))
                            ]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "right",
                                  color: "#8492a6",
                                  "font-size": "13px"
                                }
                              },
                              [_vm._v(_vm._s(item.langCode))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.content } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.v1,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "v1", $$v)
                      },
                      expression: "form.v1"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.dialogFormVisibleNO } }, [
                _vm._v(_vm._s(_vm.$t("LanguageSet.cancel")))
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.dialogFormVisibleYES }
                },
                [_vm._v(_vm._s(_vm.$t("LanguageSet.confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }